module.exports = __webpack_public_path__ + "img/logo-pb.310ca3db.png";